<template>
    <div class="home">
        <section class="hero is-large has-background-success-light">
            <div class="hero-body">
                <div class="container has-text-centered" v-if="!$store.state.authUser">
                    <p class="title">
                        Your Portfolio just got Greener
                    </p>
                    <router-link :to="{name: 'Login'}">
                        <b-button size="is-large" type="is-success"><b>Sign in to get started</b></b-button>
                    </router-link>
                </div>
                <div class="container has-text-centered" v-else>
                    <p class="title" v-if="$store.state.profile">
                        Welcome back, {{$store.state.profile.forename}}
                    </p>
                    <div v-if="$store.state.profile">
                        <b-button size="is-large" v-if="$store.state.profile.portfolioRef" type="is-danger"
                                  @click="getReport">View
                            Portfolio Report
                        </b-button>
                        <br class="my-3">
                        <b-upload v-model="file" class="file-label mt-3" accept=".csv" @input="uploadPortfolio">
                            <a class="button is-success">
                                Upload new portfolio
                            </a>
                        </b-upload>

                    </div>

                </div>

            </div>
        </section>
        <div id="report" class="content-card-wrap">
            <div v-if="global_data">
                <div class="container has-text-centered">
                    <p class="title mt-6 is-2">Investments by Sector: </p>
                    <div class="content-cards">

                    </div>
                    <div class="card my-5" style="width: 100%">
                        <div class="card-header">
                            <p class="card-header-title">Global</p>

                        </div>
                        <div class="card-content">
                            <pie :labels="sector_data.labels" :datasets="[{
                            label: 'Global',
                            data: sector_data.data,
                             backgroundColor: [
                              'rgba(255, 99, 132, 0.2)',
                              'rgba(255, 159, 64, 0.2)',
                              'rgba(255, 205, 86, 0.2)',
                              'rgba(75, 192, 192, 0.2)',
                              'rgba(54, 162, 235, 0.2)',
                              'rgba(153, 102, 255, 0.2)',
                              'rgba(201, 203, 207, 0.2)',
                              'rgba(160,56,81,0.2)',
                              'rgba(138,90,42,0.2)',
                              'rgba(145,118,56,0.2)',
                              'rgba(54,126,126,0.2)',
                              'rgba(58,104,136,0.2)',
                              'rgba(71,49,115,0.2)',
                              'rgba(50,72,117,0.2)'
                            ],
                            borderColor: [
                              'rgb(255, 99, 132)',
                              'rgb(255, 159, 64)',
                              'rgb(255, 205, 86)',
                              'rgb(75, 192, 192)',
                              'rgb(54, 162, 235)',
                              'rgb(153, 102, 255)',
                              'rgb(201, 203, 207)',
                              'rgba(160,56,81)',
                              'rgba(138,90,42)',
                              'rgba(145,118,56)',
                              'rgba(54,126,126)',
                              'rgba(58,104,136)',
                              'rgba(71,49,115)',
                              'rgba(50,72,117)'
                            ],
                            borderWidth: 1
                        }]"></pie>
                        </div>
                    </div>
                </div>
                <div class="container has-text-centered">
                    <p class="title my-6 is-2">CO2 Emissions from your investments: </p>
                    <div class="card">
                        <div class="card-header">
                            <p class="card-header-title">Direct Emissions</p>
                        </div>
                        <div class="card-content">
                            <scatter
                                    xlabel = "Position Size (USD)"
                                    ylabel = "Annual Direct CO2 Emissions (tonnes)"
                                    :datasets="[{label: 'CO2', data: co2_data, backgroundColor: 'rgb(255, 99, 132)'}]"></scatter>
                        </div>
                    </div>
                    <div class="card mt-5">
                        <div class="card-header">
                            <p class="card-header-title">Indirect Emissions</p>
                        </div>
                        <div class="card-content">
                            <scatter
                                    xlabel = "Position Size (USD)"
                                    ylabel = "Annual Indirect CO2 Emissions (tonnes)"
                                    :datasets="[{label: 'CO2', data: co2_data_indirect, backgroundColor: 'rgb(77,79,250)'}]"></scatter>
                        </div>
                    </div>
                </div>

                <div class="container has-text-centered">
                    <p class="title mt-6 is-2">Holdings by Environmental Performance: </p>
                    <div class="content-cards">

                    </div>
                    <div class="card my-5" style="width: 100%">
                        <div class="card-header">
                            <p class="card-header-title">Global</p>

                        </div>
                        <div class="card-content">
                            <barchart :labels="global_data.labels" xlabel="Performance Band" ylabel="Total Holdings (USD)" :datasets="[{
                            label: 'Global',
                            data: global_data.data,
                             backgroundColor: [
                              'rgba(153, 102, 255, 0.2)',
                              'rgba(54, 162, 235, 0.2)',
                              'rgba(75, 192, 192, 0.2)',
                              'rgba(255, 205, 86, 0.2)',
                              'rgba(255, 159, 64, 0.2)',
                              'rgba(255, 99, 132, 0.2)',
                              'rgba(201, 203, 207, 0.2)',
                            ],
                            borderColor: [
                                'rgb(153, 102, 255)',
                                'rgb(54, 162, 235)',
                                'rgb(75, 192, 192)',
                                'rgb(255, 205, 86)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 99, 132)',
                              'rgb(201, 203, 207)'
                            ],
                            borderWidth: 1
                        }]"></barchart>
                        </div>
                    </div>
                    <div class="container">
                        <p class="title mt-6 is-4">By Country:
                            <b-button class="ml-4" style="position: relative;top:-5px;" type="is-info" @click="show_countries = !show_countries">{{show_countries ? 'Hide' :
                                'Show'}}
                            </b-button>
                        </p>

                    </div>

                    <div class="content-cards my-3" v-if="show_countries">

                        <div class="card" v-for="(country, index) in this.country_data" :key="index">
                            <div class="card-header">
                                <p class="card-header-title">{{country.name}}</p>

                            </div>
                            <div class="card-content">
                                <barchart xlabel="Performance Band" ylabel="Total Holdings (USD)" :labels="country.labels" :datasets="[{
                            label: country.name,
                            data: country.data,
                             backgroundColor: [
                              'rgba(153, 102, 255, 0.2)',
                              'rgba(54, 162, 235, 0.2)',
                              'rgba(75, 192, 192, 0.2)',
                              'rgba(255, 205, 86, 0.2)',
                              'rgba(255, 159, 64, 0.2)',
                              'rgba(255, 99, 132, 0.2)',
                              'rgba(201, 203, 207, 0.2)',
                            ],
                            borderColor: [
                                'rgb(153, 102, 255)',
                                'rgb(54, 162, 235)',
                                'rgb(75, 192, 192)',
                                'rgb(255, 205, 86)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 99, 132)',
                              'rgb(201, 203, 207)'
                            ],
                            borderWidth: 1
                        }]"></barchart>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="content-card-wrap">
                    <p class="title mt-6 is-2">List of investments: </p>
                    <div class="content-cards-multi">
                        <div class="card my-3" v-for="(holding, index) in this.holdings" :key="index">
                            <div class="card-header">
                                <p class="card-header-title">{{holding['company_name']}} ({{holding['ticker_symbol']}})</p>
                            </div>
                            <div class="card-content" style="height: 100%"
                                 :class="{
                                    'A': 'has-background-primary-light',
                                    'A-': 'has-background-info-light',
                                    'B': 'has-background-success-light',
                                    'C': 'has-background-warning-light',
                                    'D': 'has-background-danger-light'}[holding['performance_band']]"
                            >
                                <p>Performance Band:
                                    <b-tag
                                            rounded
                                            :class="{
                                    'A': 'is-primary',
                                    'A-': 'is-info',
                                    'B': 'is-success',
                                    'C': 'is-warning',
                                    'D': 'is-danger'

                                }[holding['performance_band']]"
                                    >{{holding['performance_band']}}
                                    </b-tag>
                                </p>
                                <p>Annual CO2 (t): {{holding['scope_1_metric_tonnes_co2e']}}</p>
                            </div>
                            <div class="card-footer">
                                <div class="card-footer-item">
                                    <b-tag size="is-large" type="is-dark" class="">${{holding['position_size']}}</b-tag>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import pie from "../components/pie";
    import barchart from "../components/barchart";
    import firebase from "firebase/app"
    import "firebase/storage"
    import db from '../firebase/firebaseInit'
    import * as dfd from "danfojs"
    import Scatter from "../components/scatter";

    export default {
        name: 'Home',
        components: {
            Scatter,
            barchart,
            pie
        },
        data() {
            return {
                file: null,
                holdings: [],
                country_data: [],
                global_data: null,
                co2_data: [],
                co2_data_indirect: [],
                sector_data: null,
                show_countries: false,
            }
        },
        methods: {
            uploadPortfolio() {
                let storageRef = firebase.storage().ref()
                let folioRef = storageRef.child(`portfolios/${this.$store.state.authUser.uid}.csv`)
                folioRef.put(this.file).then(() => {
                    db.collection('users').doc(this.$store.state.authUser.uid).update({portfolioRef: this.$store.state.authUser.uid})
                    console.log('Uploaded!')
                    this.getReport()

                })
            },
            async getReport() {
                let data_url = "https://firebasestorage.googleapis.com/v0/b/hackathon-1f4cc.appspot.com/o/sectordata.csv?alt=media&token=920fc385-50df-465a-a3b7-7dd15cd4d7d5"
                let df = await dfd.readCSV(data_url)
                let port_url = await firebase.storage().ref(`portfolios/${this.$store.state.authUser.uid}.csv`).getDownloadURL()
                let port = await dfd.readCSV(port_url)
                let fdf = dfd.merge({"left": df, "right": port, "on": ['ticker_symbol'], "how": "inner"})
                fdf = fdf.fillNa('No Data').sortValues('position_size', {ascending: false})
                this.holdings = fdf.toJSON()
                // let data_files = ['A', 'A-', 'B', 'C', 'D', 'E', 'N']
                // let color_list = ['r', 'g', 'b', 'y']
                // let color_dict = {'A':'green', 'A-': 'red', 'B':'blue', 'C': 'cyan', 'D':'green', 'E': 'red', 'N':'blue'}
                // function f(x) {
                //   console.log(x)
                //   let a = x['ticker_symbol'].nUnique()
                //   let b = x['position_size'].sum()
                //   let c = b/a
                //   let filt = x.loc(fdf['position_size'] > 0)
                //   a = filt['ticker_symbol'].nUnique()
                //   return new dfd.Series([a,b,c],{"index": ['nunq', 'pos_size', 'avg_size']})
                // }
                //
                // let bar = fdf.groupby(['performance_band']).apply(f)
                // let test = bar.T
                // console.log(test)
                try {
                    let countries = fdf['country'].unique().sortValues('country')
                    for (let i of countries.$data) {
                        let grouped = fdf.loc({
                            "rows": fdf['country'].eq(i),
                            "columns": ["performance_band", "position_size"]
                        })
                        let bar = grouped.groupby(['performance_band']).col(['position_size']).sum().sortValues('performance_band')
                        let co = {
                            name: i,
                            labels: [],
                            data: [],
                        }
                        for (let j of bar.$data) {
                            co.labels.push(j[0])
                            co.data.push(j[1])
                        }
                        this.country_data.push(co)
                    }
                } catch (e) {
                    console.log(e)
                }

                this.country_data.reverse()

                let bar = fdf.groupby(['performance_band']).col(['position_size']).sum().sortValues('performance_band').dropNa()
                let co = {
                    name: 'Global',
                    labels: [],
                    data: [],
                }
                for (let j of bar.$data) {
                    co.labels.push(j[0])
                    co.data.push(j[1])
                }
                this.global_data = co

                let x = fdf.column('position_size').$data
                let y = fdf.column('scope_1_metric_tonnes_co2e').$data
                for (let i = 0; i < x.length; i++) {
                    this.co2_data.push({x: x[i], y: y[i], label: 'dsfhkjh'})
                }

                let x2 = fdf.column('position_size').$data
                let y2 = fdf.column('scope_2_metric_tonnes_co2e').$data
                for (let i = 0; i < x.length; i++) {
                    this.co2_data_indirect.push({x: x2[i], y: y2[i], label: 'dsfhkjh'})
                }

                let bar2 = fdf.groupby(['sector']).col(['position_size']).sum().dropNa()
                let co2 = {
                    name: 'Global',
                    labels: [],
                    data: [],
                }
                for (let j of bar2.$data) {
                    co2.labels.push(j[0])
                    co2.data.push(j[1])
                }
                this.sector_data = co2


                var elmnt = document.getElementById("report");
                elmnt.scrollIntoView();

            }
        }
    }
</script>
<style lang="scss">
    .card {
        display: flex;
        flex-direction: column;
        transition: 0.3s ease all;
        cursor: pointer;

        &:hover {
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }
    }

    .content-card-wrap {
        position: relative;
        padding: 20px;

        .content-cards {
            display: grid;
            gap: 32px;
            grid-template-columns: 1fr;
            @media (min-width: 960px) {
                grid-template-columns: repeat(2, 1fr);
            }
            @media (min-width: 1200px) {
                grid-template-columns: repeat(3, 1fr);
            }
        }

        .content-cards-multi {
            display: grid;
            gap: 32px;
            grid-template-columns: 1fr;
            @media (min-width: 960px) {
                grid-template-columns: repeat(3, 1fr);
            }
            @media (min-width: 1200px) {
                grid-template-columns: repeat(5, 1fr);
            }
        }
    }
</style>
